import React from 'react';

interface AdPriceObject {
  standard: string,
  premium: string
}
declare const adPriceObject: AdPriceObject;

export default function Notice({ formik }) {
  const price = formik.values.adLevel === 'Standard' ? adPriceObject.standard : adPriceObject.premium;

  return (
    <div>
      <p>You will receive an invoice from Meatex for the sum of <strong>£{price}.00</strong> + VAT once your advert has been approved.</p>
      <p>We treat your personal data with care; please find our <a href="/privacy-policy/">privacy notice</a> here.</p>
    </div>
  );
}
